import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [stage, setStage] = useState('request'); // 'request' | 'verify'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const getFriendlyError = (errorCode) => {
    switch (errorCode) {
      case 'user_not_found':
        return 'We could not find an account with that email. If you have not purchased access yet, please support the project to get access.';
      case 'invalid_code':
        return 'That code looks incorrect. Please try again.';
      case 'code_expired':
        return 'This code has expired. Please request a new one.';
      case 'code_used':
        return 'This code was already used. Please request a new one.';
      case 'email_required':
        return 'Please enter your email address.';
      case 'email_and_code_required':
        return 'Please enter your email and the 6-digit code.';
      default:
        return 'Something went wrong. Please try again.';
    }
  };

  const requestCode = async () => {
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${API_BASE}/auth/request-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        credentials: 'include',
      });
      const data = await res.json();
      if (res.ok) {
        setStage('verify');
      } else {
        setMessage(getFriendlyError(data.error) || 'Failed to request code');
      }
    } catch (e) {
      setMessage('Network error');
    } finally {
      setLoading(false);
    }
  };

  const login = async () => {
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, name }),
        credentials: 'include',
      });
      const data = await res.json();
      if (res.ok) {
        window.location.href = '/downloads';
      } else {
        setMessage(getFriendlyError(data.error) || 'Login failed');
      }
    } catch (e) {
      setMessage('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10 }}>Login</h2>
      {stage === 'request' && (
        <div style={{ maxWidth: 360 }}>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: '8px 12px', marginBottom: 10 }}
          />
          <button className="btn btn-primary" disabled={loading || !email} onClick={requestCode} style={{ margin:0, marginTop: 20 }}>
            {loading ? 'Sending…' : 'Send login code'}
          </button>
          {message && <div style={{ marginTop: 10, color: '#a33', fontSize: 12 }}>{message}</div>}
        </div>
      )}

      {stage === 'verify' && (
        <div style={{ maxWidth: 360 }}>
          <input
            type="text"
            placeholder="Name (optional)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: '100%', padding: '8px 12px', marginBottom: 10 }}
          />
          <input
            type="text"
            placeholder="6-digit code sent to your inbox"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            style={{ width: '100%', padding: '8px 12px', marginBottom: 10 }}
          />
          <button className="btn btn-primary" disabled={loading || code.length !== 6} onClick={login} style={{ margin:0, marginTop: 20 }}>
            {loading ? 'Logging in…' : 'Login'}
          </button>
          {message && <div style={{ marginTop: 10, color: '#a33', fontSize: 12 }}>{message}</div>}
        </div>
      )}
    </div>
  );
}


